module.exports = __webpack_public_path__ + "static/media/S1N5-5.12a3616f.svg";